import React, { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const FitPoints = ({ points }) => {
  const map = useMap();

  useEffect(() => {
    const coords = points
      .filter((p) => p.latitude != null && p.longitude != null)
      .map((p) => [p.latitude, p.longitude]);
    if (coords.length === 0) {
      map.setView([46.99, 3.16], 9);
      return;
    }
    if (coords.length === 1) {
      map.setView(coords[0], 14);
      return;
    }
    map.fitBounds(coords, { padding: [36, 36] });
  }, [map, points]);

  return null;
};

const numberedIcon = (num, color) =>
  L.divIcon({
    className: 'kkp-distrib-marker',
    html: `<span style="background:${color}">${num}</span>`,
    iconSize: [28, 28],
    iconAnchor: [14, 28],
    popupAnchor: [0, -24],
  });

const KkpDistribMap = ({ points = [], zoneColors = {}, height = 640 }) => {
  const mapped = useMemo(
    () => points.filter((p) => p.latitude != null && p.longitude != null),
    [points],
  );

  return (
    <div className="kkp-distrib-map rounded overflow-hidden border" style={{ height }}>
      <MapContainer
        center={[46.99, 3.16]}
        zoom={9}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitPoints points={mapped} />
        {mapped.map((point, index) => {
          const color = zoneColors[point.zone] || point.zone_couleur || '#BE123C';
          return (
            <Marker
              key={point.id}
              position={[point.latitude, point.longitude]}
              icon={numberedIcon(index + 1, color)}
            >
              <Popup>
                <strong>{point.nom}</strong>
                <br />
                {point.adresse}
                {point.ville ? <><br />{point.code_postal} {point.ville}</> : null}
                <br />
                <small>
                  {point.zone_label} · MAG {point.qte_mag} · SET {point.qte_set}
                </small>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default KkpDistribMap;
